const SELECTORS = {
  drawerMenu: '[data-drawer-menu]',
  promoWrapper: '.drawer-menu__promo-wrapper',
  menuItem: '.drawer-menu__item[data-menu-title]',
  parentLink: '[data-item="parent"]',
  backButton: '[data-item="back"]',
  primaryLinks: '.drawer-menu__primary-links.drawer-menu-list--0',
};

const CLASSES = {
  promoVisible: 'is-visible',
  hasFullHeight: 'has-full-height',
};

function initDrawerMenuPromo(): void {
  const drawerMenu = document.querySelector<HTMLElement>(SELECTORS.drawerMenu);
  if (!drawerMenu) return;

  const promoWrapper = drawerMenu.querySelector<HTMLElement>(SELECTORS.promoWrapper);
  if (!promoWrapper) return;

  const promoMenuTitle = promoWrapper.dataset.promoMenu;
  if (!promoMenuTitle) return;

  const primaryLinks = drawerMenu.querySelector<HTMLElement>(SELECTORS.primaryLinks);

  const targetMenuItem = drawerMenu.querySelector<HTMLElement>(
    `${SELECTORS.menuItem}[data-menu-title="${promoMenuTitle}"]`
  );

  const updatePromoVisibility = (): void => {
    if (!targetMenuItem) {
      promoWrapper.classList.remove(CLASSES.promoVisible);
      primaryLinks?.classList.remove(CLASSES.hasFullHeight);
      return;
    }

    const isInTargetMenu = targetMenuItem.classList.contains('child-visible');
    
    if (isInTargetMenu) {
      setTimeout(() => {
        promoWrapper.classList.add(CLASSES.promoVisible);
        primaryLinks?.classList.add(CLASSES.hasFullHeight);
      }, 150);
    } else {
      promoWrapper.classList.remove(CLASSES.promoVisible);
    }
  };

  drawerMenu.addEventListener('click', (e) => {
    const target = e.target as HTMLElement;
    
    if (target.closest(SELECTORS.promoWrapper)) return;
    
    const isNavClick = target.closest(SELECTORS.parentLink) || target.closest(SELECTORS.backButton);
    
    if (isNavClick) {
      promoWrapper.classList.remove(CLASSES.promoVisible);
      primaryLinks?.classList.remove(CLASSES.hasFullHeight);
      
      setTimeout(updatePromoVisibility, 100);
    }
  }, true);
}

document.addEventListener('DOMContentLoaded', initDrawerMenuPromo);
